import { render, staticRenderFns } from "./ClosedWap.vue?vue&type=template&id=45ccfef8&scoped=true&"
import script from "./ClosedWap.vue?vue&type=script&lang=js&"
export * from "./ClosedWap.vue?vue&type=script&lang=js&"
import style0 from "./ClosedWap.vue?vue&type=style&index=0&id=45ccfef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ccfef8",
  null
  
)

export default component.exports